
// English translation for autoplay overlay
export const autoplayOverlay = {
  enableAutoplay: 'Enable autoplay',
  autoplayDescription: 'Video will play automatically when page loads',
  autoplayCountdown: 'Video will play in {seconds} seconds',
  clickToPlay: 'Click to play',
  clickToUnmute: 'Click to unmute',
  autoplayDisabled: 'Autoplay disabled',
  autoplayUnavailable: 'Autoplay not available in this browser',
  autoplayRequiresInteraction: 'This browser requires user interaction to autoplay',
  autoplayAllowed: 'Autoplay allowed',
  autoplayAllowedMuted: 'Autoplay allowed (muted)',
  enableMutedAutoplay: 'Enable muted autoplay',
  
  // Additional autoplay overlay translations
  autoplayOverlay: 'Autoplay Overlay',
  enableAutoplayOverlay: 'Enable Autoplay Overlay',
  customizeOverlay: 'Customize Overlay',
  autoplayTextTop: 'Top Text',
  autoplayTextBottom: 'Bottom Text',
  enablePulseAnimation: 'Enable Pulse Animation',
  enableWhiteBorder: 'Add White Border',
  customImage: 'Custom Image',
  uploadCustomImage: 'Upload Custom Image',
  removeImage: 'Remove Image',
  useTemplate: 'Use Template',
  useCustomImage: 'Use Custom Image',
  templates: 'Templates',
  clickToActivate: 'Click to Activate'
};

// Sales notification translations
export const salesNotification = {
  enableSalesNotification: 'Enable Sales Notifications',
  notificationType: 'Notification Type',
  simulated: 'Simulated',
  webhook: 'Webhooks',
  notificationFrequency: 'Notification Frequency',
  startDelay: 'Start Delay',
  secondsBeforeShowingFirstNotification: 'Seconds before showing first notification',
  intervalBetweenNotifications: 'Interval between notifications',
  notificationInterval: 'Notification Interval',
  timeBetweenConsecutiveNotifications: 'Time between consecutive notifications',
  notificationDuration: 'Notification Duration',
  timeEachNotificationStaysVisible: 'Time each notification stays visible',
  loopInfinitely: 'Loop Infinitely',
  continueShowingNotificationsIndefinitely: 'Continue showing notifications indefinitely',
  notificationPosition: 'Notification Position',
  notificationTemplate: 'Notification Template',
  namesList: 'Names List',
  citiesList: 'Cities List',
  productName: 'Product Name',
  platform: 'Platform',
  perfectPay: 'PerfectPay',
  monetizze: 'Monetizze',
  vegaCheckout: 'Vega Checkout',
  customPlatformIcon: 'Custom Platform Icon',
  uploadCustomIconOptional: 'Upload a custom icon (optional)',
  fontSize: 'Font Size',
  animation: 'Animation',
  enableSound: 'Enable Sound',
  playSoundWhenNotificationAppears: 'Play a sound when notification appears',
  redirectUrl: 'Redirect URL',
  notificationWillBeClickable: 'Notification will be clickable and redirect to this URL',
  testNotificationNow: 'Test Notification Now',
  small: 'Small',
  medium: 'Medium',
  large: 'Large'
};
